import { Sparkles, Code2, ShieldCheck, Bug } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import CodeExplainer from "@/components/CodeExplainer";
import ToolPageShell from "@/components/tools/ToolPageShell";

const faqs = [
  { q: "What languages are supported?", a: "Any language the model recognizes — JavaScript, TypeScript, Python, Go, Rust, Java, PHP, SQL, Bash, and more. Just paste the code." },
  { q: "Will my code be stored?", a: "No. We forward the snippet to the AI model to generate the explanation and return the result. Nothing is logged or stored on our servers." },
  { q: "Can it find bugs?", a: "It often spots common issues like off-by-one errors, missing null checks, race conditions, and security smells — but it's not a substitute for code review or static analysis." },
  { q: "Is there a length limit?", a: "Yes — about 12,000 characters per request. Paste the most relevant function or section if your file is larger." },
];

const CodeExplainerPage = () => (
  <>
    <SEOHead
      title="Free AI Code Explainer — Explain Any Code Snippet"
      description="Paste any code and get a clear, AI-powered explanation: summary, step-by-step walkthrough, and likely bugs. Free, no sign-up."
      path="/tools/code-explainer"
      keywords="code explainer, AI code explanation, what does this code do, explain code online, code walkthrough, free AI tool"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Free Tools", path: "/tools" },
        { name: "Code Explainer", path: "/tools/code-explainer" },
      ]}
      jsonLd={[
        { "@context": "https://schema.org", "@type": "WebApplication", name: "NETIUS Code Explainer", url: "https://netius.com/tools/code-explainer", applicationCategory: "DeveloperApplication", operatingSystem: "Any (Web)", offers: { "@type": "Offer", price: "0", priceCurrency: "USD" } },
        { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
      ]}
    />
    <ToolPageShell
      title="AI Code Explainer"
      subtitle="Paste any code and get a plain-English summary, a step-by-step walkthrough, and a list of likely bugs or improvements."
      badges={[
        { icon: Sparkles, label: "AI-powered" },
        { icon: ShieldCheck, label: "Nothing stored" },
        { icon: Code2, label: "Any language" },
      ]}
      featuresHeading="What it does"
      features={[
        { icon: Code2, title: "Plain-English summary", description: "One paragraph telling you what the code does and why it exists." },
        { icon: Sparkles, title: "Step-by-step walkthrough", description: "Goes line-by-line so juniors and reviewers can follow along quickly." },
        { icon: Bug, title: "Bug & improvement hints", description: "Flags common issues, edge cases and quick wins so you ship cleaner code." },
      ]}
      faqSubheading="Quick answers about the AI code explainer."
      faqs={faqs}
      softCtaText="Need a senior engineer reviewing your codebase?"
    >
      <CodeExplainer />
    </ToolPageShell>
  </>
);

export default CodeExplainerPage;